export default {
  translation: {
    nav: {
      home: 'Hjem',
      trips: 'Rejser',
      aboutUs: 'Om os',
      alerts: 'Beskeder',
      wishlist: 'Ønskeliste',
      language: 'Sprog',
      profile: 'Profil',
      settings: 'Indstillinger',
      signIn: 'Log ind',
      signUp: 'Tilmeld'
    },
    hero: {
      title: 'Udforsk Uganda',
      subtitle: 'og videre ud',
      description: 'Oplev Afrikas perle med ekspertguider. Uforglemmelige oplevelser venter i Ugandas betagende landskaber og levende kultur.',
      searchPlaceholder: 'Hvor vil du hen?',
      categories: {
        all: 'Alle',
        wildlife: 'Dyreliv',
        safari: 'Safari',
        cultural: 'Kultur',
        adventure: 'Eventyr',
        birding: 'Fuglekiggeri'
      }
    },
    common: {
      from: 'fra',
      reviews: 'anmeldelser',
      viewMore: 'Vis mere',
      book: 'Book',
      seeAll: 'Se alle',
      loading: 'Indlæser...'
    }
  }
};